// get the div element
const minimize = document.getElementById("minimize");
const maximizeTop = document.getElementById("maximizeTop");
const maximizeBottom = document.getElementById("maximizeBottom");
const element = document.getElementById("minimize-container");
// @see https://262.ecma-international.org/5.1/#sec-9.2
if (minimize) {
    // add a click event listener to the div
    minimize.addEventListener('click', function() {
        einklappen()
        console.log("minimize")
    });
}
if (maximizeTop) {
    maximizeTop.addEventListener('click', function() {
        ausklappen()
        console.log("maximize")
    });
}
if (maximizeBottom) {
    maximizeBottom.addEventListener('click', function() {
        ausklappen()
        console.log("maximize")
    });
}
function ausklappen() {

    // minimize.style.visibility = "visible";
    minimize.style.display = "block";
    // maximizeTop.style.visibility = "hidden";
    maximizeTop.style.display = "none";
    maximizeBottom.style.visibility = "hidden";
    element.classList.remove("max-h-[700px]")
}
function einklappen() {
    // minimize.style.visibility = "hidden";
    minimize.style.display = "none";
    // maximizeTop.style.visibility = "visible";
    maximizeTop.style.display = "block";
    maximizeBottom.style.visibility = "visible";
    element.classList.add("max-h-[700px]")
    element.classList.add("overflow-hidden")
}
